import React, { useEffect, useState } from 'react'
import ReactCodeInput from 'react-code-input'
import styles from '../../../../modules/auth/confirmation/confirmation.module.scss'
import useCountDown from 'utilities/hooks/countDown'
import { toEnglishDigits } from 'utilities/helper/toEnglishNumber'
import { useModalVisibility } from '../hooks/useModalVisibility'
import UseSendCodeForPromissory from 'modules/promissory/hooks/UseSendCode'
import UseSendAuthentication from '../hooks/useSendAuthentication'

interface IModalProps {
    show: boolean
    onClose: () => void
    phone: string
}

const PromissoryModal = ({ show, onClose, phone }: IModalProps) => {
    const [confirmCode, setConfirmCode] = useState('')
    const [isSubmit, setIsSubmit] = useState(false)
    const isVisible = useModalVisibility(show)

    const { currentSeconds, currentMinutes, isRunning, startHandler } =
        useCountDown()
    const { isLoading: sendCodeLoading, mutate: sendCodeMutate } =
        UseSendCodeForPromissory()
    const { mutate: confirmCodeMutate } = UseSendAuthentication(setIsSubmit)

    useEffect(() => {
        if (confirmCode.length === 4 && !isSubmit) {
            setIsSubmit(true)
            confirmCodeMutate({
                code: toEnglishDigits(confirmCode),
                phone_number: phone,
            })
        }
    }, [confirmCode])

    useEffect(() => {
        startHandler()
    }, [show])

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            if (currentMinutes === '02' && currentSeconds === '00') {
                onClose()
            }
        }
    }

    const sendCode = () => {
        if (phone) {
            sendCodeMutate({ phone_number: phone })
            startHandler()
        } else {
            console.error('Phone number is missing')
        }
    }

    if (!isVisible) return null

    return (
        <div
            className={`fixed inset-0 z-50 flex items-center bg-gray-2 bg-opacity-75 h-screen justify-center transition-opacity duration-300 ${
                show ? 'opacity-100' : 'opacity-0'
            }`}
            onClick={handleOverlayClick}
        >
            <div className="bg-white p-6 rounded-lg w-full max-w-md mx-2">
                <p className="text-center mt-4 text-green-1 text-xl mb-3">
                    احراز هویت صادر کننده سفته
                </p>
                <p className="text-center text-sm mb-4">
                    لطفا کد تایید ارسال شده به شماره‌ {phone && `${phone}`} را
                    وارد نمایید
                </p>
                <div className="mb-2">
                    <div dir="ltr">
                        <ReactCodeInput
                            value={confirmCode}
                            name="confirmCode"
                            fields={4}
                            className={styles['reactCode-input']}
                            inputMode="numeric"
                            onChange={(e) => setConfirmCode(e)}
                        />
                    </div>
                </div>
                {isRunning ? (
                    <p className="text-center text-gray-3 mb-2">
                        ارسال مجدد: {currentMinutes.toString().padStart(2, '0')}
                        :{currentSeconds.toString().padStart(2, '0')}
                    </p>
                ) : sendCodeLoading ? (
                    <p className="text-center">در حال ارسال...</p>
                ) : (
                    <p
                        className="text-center text-cyan-2 cursor-pointer mb-2"
                        onClick={sendCode}
                    >
                        ارسال مجدد
                    </p>
                )}
            </div>
        </div>
    )
}

export default PromissoryModal
